module.exports = __webpack_public_path__ + "components/rewards/coolbus/static/icon-784ab81063e1831d4bc57410db5e0658.svg";